import {
  WorkflowBuilderReduxProvider as Provider,
  workflowBuilderConfigureStore as configureStore,
  workflowBuilderCreateSlice as createSlice,
  useWorkflowBuilderDispatch as useDispatch,
  useWorkflowBuilderSelector as useSelector,
} from '@automata/workflow-builder';
import { PropsWithChildren, useMemo } from 'react';

type WorkflowUiState = {
  useWorkcellTransportConfiguration: boolean;
};

const initialState: WorkflowUiState = {
  useWorkcellTransportConfiguration: false,
};

const workflowUiSlice = createSlice({
  name: 'workflowUi',
  initialState,
  reducers: {
    setUseWorkcellTransportConfiguration: (state, action) => {
      state.useWorkcellTransportConfiguration = action.payload;
    },
  },
});

export const { setUseWorkcellTransportConfiguration } = workflowUiSlice.actions;

export const createWorkflowUiStore = () =>
  configureStore({
    reducer: {
      workflowUi: workflowUiSlice.reducer,
    },
  });

type WorkflowUiStore = ReturnType<typeof createWorkflowUiStore>;
type WorkflowUiRootState = ReturnType<WorkflowUiStore['getState']>;
type WorkflowUiDispatch = WorkflowUiStore['dispatch'];

export const selectUseWorkcellTransportConfiguration = (
  state: WorkflowUiRootState
) => state.workflowUi.useWorkcellTransportConfiguration;

export const useWorkflowUiDispatch = () => useDispatch<WorkflowUiDispatch>();
export const useWorkflowUiSelector = <T,>(
  selector: (state: WorkflowUiRootState) => T
) => useSelector(selector);

type WorkflowUiStateProviderProps = PropsWithChildren<{
  workflowId: string;
  initialUseWorkcellTransportConfiguration?: boolean;
}>;

export const WorkflowUiStateProvider = ({
  children,
  initialUseWorkcellTransportConfiguration = false,
}: WorkflowUiStateProviderProps): JSX.Element => {
  const store = useMemo(() => {
    const store = createWorkflowUiStore();
    store.dispatch(
      setUseWorkcellTransportConfiguration(
        initialUseWorkcellTransportConfiguration
      )
    );
    return store;
  }, [initialUseWorkcellTransportConfiguration]);

  return <Provider store={store}>{children}</Provider>;
};
